import React from 'react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { AlertTriangle, CheckCircle } from 'lucide-react';

export function DecisionConfirmModal({ isOpen, decision, refundPercent, orderTotal, isTestMode, isPending, onConfirm, onCancel }) {
  if (!isOpen) return null;

  const getDecisionTitle = () => {
    switch (decision) {
      case 'refund':
        return `Issue ${refundPercent}% Refund`;
      case 'reject':
        return 'Reject Dispute';
      case 'fix':
        return 'Schedule Fix & Re-delivery';
      default:
        return 'Confirm Decision';
    }
  };

  const getDecisionDescription = () => {
    switch (decision) {
      case 'refund':
        const refundAmount = (orderTotal * refundPercent / 10000).toFixed(2);
        return `This will refund $${refundAmount} to the buyer and adjust the seller's payout accordingly. This action is irreversible.`;
      case 'reject':
        return 'This will reject the dispute and release the full payment to the seller. The buyer will not receive a refund.';
      case 'fix':
        return 'This will request the seller to fix and re-deliver the work by the specified deadline. Auto-approval will remain paused.';
      default:
        return '';
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={onCancel} />
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-xl z-50 max-w-md w-full mx-4">
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              {decision === 'reject' ? (
                <CheckCircle className="h-6 w-6 text-green-600" />
              ) : (
                <AlertTriangle className="h-6 w-6 text-orange-600" />
              )}
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">{getDecisionTitle()}</h3>
              <p className="text-sm text-gray-600 mt-2">{getDecisionDescription()}</p>
            </div>
          </div>

          {isTestMode && (
            <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
                Stripe: TEST MODE
              </Badge>
              <p className="text-xs text-yellow-900 mt-2">
                This will execute in Stripe test mode. No real money will be transferred.
              </p>
            </div>
          )}

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={isPending}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              disabled={isPending}
              className="flex-1"
            >
              {isPending ? 'Executing...' : 'Confirm Decision'}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
